import React, { useState, useEffect, useRef } from "react"

import {
    Label,
    Card,
    CardBody,
    Button,
    Col,
    Form,
    Input,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    CardTitle,
    CardImg,
} from "reactstrap"
import classnames from "classnames"
import { AvForm, AvField } from "availity-reactstrap-validation"

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Select from "react-select"

import { Editor } from "react-draft-wysiwyg"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import { EditorState, ContentState } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import { stateFromHTML } from 'draft-js-import-html';
import Axios from "../../../helpers/axios_helper"
import * as CHelper from "../../../helpers/custom_helper"
import { useHistory, Link } from "react-router-dom"
import { toast } from 'react-toastify/dist/react-toastify';
import mediaImage from "../../../assets/images/media.jpeg";
const moment = require('moment');

const Model = (props) => {
    const history = useHistory()
    const [activeTab, setactiveTab] = useState(1)
    const [eventTypes, setEventTypes] = useState([]);
    const [eventTypeId, setEventTypeId] = useState()
    const [eventDate, setEventDate] = useState(false)
    const [updateData, setUpdateData] = useState(false)
    const [imageSrc, setImageSrc] = useState(mediaImage);
    const [files, setFiles] = useState([]);

    const [overviewState, setOverviewState] = useState(EditorState.createEmpty());
    const [overviewContent, setOverviewContent] = useState();

    function toggleTab(tab) {
        if (activeTab !== tab) {
            if (tab >= 1 && tab <= 4) {
                setactiveTab(tab)
            }
        }
    }

    const handleOverviewChange = (newEditorState) => {
        setOverviewState(newEditorState);
        setOverviewContent(stateToHTML(newEditorState.getCurrentContent()));
    };

    const handleSubmit = async (event, errors, values) => {
        window.sLoader();
        if (errors.length > 0) {
            errors.forEach(element => {
                toast.error(`${CHelper.separateCamelCaseString(element)} is required !`, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000,
                });
            });
        }
        // else if (props.id && props.id > 0 && imageSrc == mediaImage) {
        //     toast.error(`Feature image is required !`, {
        //         position: toast.POSITION.TOP_RIGHT,
        //         autoClose: 3000,
        //     });
        // }
        // else if (!props.id && files.length == 0) {
        //     toast.error(`Feature image is required !`, {
        //         position: toast.POSITION.TOP_RIGHT,
        //         autoClose: 3000,
        //     });
        // }
        else {
            if (props.id && props.id == updateData.id) {
                const jsonData = {
                    eventTypeId: eventTypeId,
                    eventName: values.eventName,
                    eventCode: values.eventCode,
                    eventDate: eventDate,
                    eventDetails: overviewContent
                }

                await Axios.patch(`/event/id/${updateData.id}`, jsonData)
                    .then(async (response) => {
                        if (response.data.status === 200) {

                            const formData = new FormData();
                            for (let i = 0; i < files.length; i++) {
                                formData.append('file', files[i]);
                            }
                            if (files.length > 0 && updateData.files) {
                                const removeFilesName = [];
                                for (let i = 0; i < updateData.files.length; i++) {
                                    removeFilesName.push(updateData.files[i].name);
                                }
                                formData.append(`remove`, JSON.stringify(removeFilesName));
                            }
                            await Axios.post(`/file/upload/event&${updateData.id}`, formData, {
                            })
                                .then(response => {
                                    toast.success('Event updated successfully!', {
                                        position: toast.POSITION.TOP_RIGHT,
                                        autoClose: 3000,
                                    });
                                    props.handleCallback(response.data)
                                })
                                .catch(function (error) {
                                    toast.error("File Uploaded Failed !", {
                                        position: toast.POSITION.TOP_RIGHT,
                                        autoClose: 3000,
                                    });
                                });
                        } else {
                            toast.error(response.data.message, {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 3000,
                            });
                        }
                    })
                    .catch((e) => {
                        toast.error(e, {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 3000,
                        });
                    })
            }
            else {
                const jsonData = {
                    eventTypeId: eventTypeId,
                    eventName: values.eventName,
                    eventCode: values.eventCode,
                    eventDate: eventDate,
                    eventDetails: overviewContent
                }

                await Axios.post("/event", jsonData)
                    .then(async (response) => {
                        if (response.data.status === 201) {

                            const formData = new FormData();
                            for (let i = 0; i < files.length; i++) {
                                formData.append('file', files[i]);
                            }

                            await Axios.post(`/file/upload/event&${response.data.id}`, formData, {
                            })
                                .then(res => {
                                    toast.success('Event created successfully!', {
                                        position: toast.POSITION.TOP_RIGHT,
                                        autoClose: 3000,
                                    });
                                    setTimeout(() => {
                                        history.push("/event-list");
                                    }, 1000);
                                })
                                .catch(function (error) {
                                    toast.error("File Uploaded Failed !", {
                                        position: toast.POSITION.TOP_RIGHT,
                                        autoClose: 3000,
                                    });
                                });
                        } else {
                            toast.error(response.data.message, {
                                position: toast.POSITION.TOP_RIGHT,
                                autoClose: 3000,
                            });
                        }
                    })
                    .catch((e) => {
                        toast.error(e, {
                            position: toast.POSITION.TOP_RIGHT,
                            autoClose: 3000,
                        });
                    })
            }
        }
        
        window.hLoader();
    }

    const fileChangeEvent = (event) => {
        let documentFile = event.target.files[0];
        setFiles([...event.target.files]);
        CHelper.convertToWebP(documentFile, setImageSrc);
    }


    useEffect(async () => {
        window.sLoader();
        if (props.id && props.id > 0) {
            await Axios.get(`/event/details/id/${props.id}`)
                .then((response) => {
                    if (response.data.status === 200) {
                        setEventTypeId(response.data.data.eventTypeId);
                        setUpdateData(response.data.data);
                        setEventDate(response.data.eventDate);
                        setOverviewContent(response.data.data.eventDetails)
                        const eventOverview = EditorState.createWithContent(stateFromHTML(response.data.data.eventDetails));
                        setOverviewState(eventOverview)

                        if(response.data.data.files.length>0){
                            setImageSrc(CHelper.getsimplifyLink(response.data.data.files[0].link))
                        }
                        
                    }
                })
        }
        await Axios.get("/eventType/dropdown")
            .then((response) => {
                if (response.data.status === 200) {
                    setEventTypes(response.data.data);
                }
                else {
                    setEventTypes([])
                }
            });

        window.hLoader();
    }, [props.id]);


    return (
        <Row>
            {(!props.id || props.id === 0 || (props.id > 0 && updateData)) &&
                <Col xl="12">
                    <Card>
                        <CardBody>
                            <AvForm className="needs-validation" onSubmit={handleSubmit}>
                                <Row>
                                    <Col lg="12">
                                        <Card>
                                            <CardBody>
                                                {/* <h4 className="card-title">Jquery Steps Wizard</h4>
                                                    <p className="card-title-desc">A powerful jQuery wizard plugin that supports
                                                                        accessibility and HTML5</p> */}
                                                <div className="form-wizard-wrapper wizard clearfix">
                                                    <div className="steps clearfix">
                                                        <ul>
                                                            <NavItem
                                                                className={classnames({ current: activeTab === 1 })}>
                                                                <NavLink
                                                                    className={classnames({ current: activeTab === 1 })}
                                                                    onClick={() => {
                                                                        // setactiveTab(1)
                                                                    }}
                                                                >
                                                                    <span className="number">1.</span>{" "}
                                                                    Basic Details
                                                                </NavLink>
                                                            </NavItem>
                                                            <NavItem className={classnames({ current: activeTab === 2 })}>
                                                                <NavLink
                                                                    className={classnames({ active: activeTab === 2 })}
                                                                    onClick={() => {
                                                                        // setactiveTab(2)
                                                                    }}
                                                                >
                                                                    <span className="number">2.</span>{" "}
                                                                    Feature Image
                                                                </NavLink>
                                                            </NavItem>
                                                            <NavItem className={classnames({ current: activeTab === 3 })}>
                                                                <NavLink
                                                                    className={classnames({ active: activeTab === 3 })}
                                                                    onClick={() => {
                                                                        // setactiveTab(3)
                                                                    }}
                                                                >
                                                                    <span className="number">3.</span>
                                                                    Description
                                                                </NavLink>
                                                            </NavItem>
                                                            <NavItem className={classnames({ current: activeTab === 4 })}>
                                                                <NavLink
                                                                    className={classnames({ active: activeTab === 4 })}
                                                                    onClick={() => {
                                                                        // setactiveTab(4)
                                                                    }}
                                                                >
                                                                    <span className="number">4.</span>
                                                                    Submit
                                                                </NavLink>
                                                            </NavItem>
                                                        </ul>
                                                    </div>
                                                    <div className="content clearfix">
                                                        <TabContent
                                                            activeTab={activeTab}
                                                            className="body"
                                                        >
                                                            <TabPane tabId={1}>

                                                                <Row>
                                                                    <Col md="12">
                                                                        <div className="mb-3">
                                                                            <Label htmlFor="eventTypeId">Event Type</Label>
                                                                            <Select
                                                                                options={eventTypes}
                                                                                value={eventTypes ? eventTypes.filter(x => x.value == eventTypeId)[0] : null}
                                                                                onChange={(e) => { setEventTypeId(e.value); }}
                                                                                name="eventTypeId"
                                                                                id="eventTypeId"
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <Col md="12">
                                                                        <div className="mb-3">
                                                                            <Label htmlFor="eventName">Event name</Label>
                                                                            <AvField
                                                                                name="eventName"
                                                                                defaultValue={updateData.eventName}
                                                                                placeholder="Name"
                                                                                type="text"
                                                                                errorMessage={`Please provide ${CHelper.separateCamelCaseString('eventName')}`}
                                                                                className="form-control"
                                                                                validate={{ required: { value: true } }}
                                                                                id="eventName"
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <Col md="6">
                                                                        <div className="mb-3">
                                                                            <Label htmlFor="eventDate">Event Date <span className="requiredSign">*</span></Label>
                                                                            <Flatpickr
                                                                                name="eventDate"
                                                                                id="eventDate"
                                                                                className="form-control d-block"
                                                                                // placeholder="dd M, yyyy"
                                                                                options={{
                                                                                    altInput: true,
                                                                                    altFormat: "F j, Y",
                                                                                    dateFormat: "Y-m-d",
                                                                                    defaultDate: updateData.eventDate?new Date(updateData.eventDate):false
                                                                                }}
                                                                                onChange={(selectedDates, dateStr, instance) => {
                                                                                    setEventDate(dateStr);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <Col md="6">
                                                                        <div className="mb-3">
                                                                            <Label htmlFor="eventCode">Event Code</Label>
                                                                            <AvField
                                                                                name="eventCode"
                                                                                defaultValue={updateData.eventCode}
                                                                                placeholder="Code"
                                                                                type="text"
                                                                                errorMessage={`Please provide ${CHelper.separateCamelCaseString('eventCode')}`}
                                                                                className="form-control"
                                                                                validate={{ required: { value: true } }}
                                                                                id="eventCode"
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </TabPane>
                                                            <TabPane tabId={2}>
                                                                <Row>
                                                                    <Col md={12}>
                                                                        <Col md={12}>
                                                                            <div className="mb-3" style={{ textAlign: "center" }}>
                                                                                <CardImg className="img-fluid" src={imageSrc} alt="" style={{ maxHeight: "300px", width: "auto" }} />
                                                                            </div>
                                                                        </Col>
                                                                        <Col md={12}>
                                                                            <div className="mb-3 justify-content-center d-flex flex-row">
                                                                                <label type="button" className="btn btn btn-info col-md-5" style={{ textAlign: "center" }}><i className="fa fa-upload"></i> Change Image<input hidden onChange={fileChangeEvent} accept="image/png, image/gif, image/jpeg, image/jpg" type="file" /></label>
                                                                                <label hidden style={{ textAlign: "center" }} type="button" onClick={() => CHelper.downloadImage(imageSrc)} className="btn btn btn-primary col-md-5"><i className="fa fa-download"></i> Download Image</label>
                                                                            </div>
                                                                        </Col>
                                                                    </Col>
                                                                </Row>
                                                            </TabPane>
                                                            <TabPane tabId={3}>
                                                                <Row>
                                                                    <Col md={12}>
                                                                        <Col md={12}>
                                                                            <div className="mb-3">
                                                                                <Label htmlFor="overviewState">Overview</Label>
                                                                                <Editor
                                                                                    editorState={overviewState}
                                                                                    onEditorStateChange={handleOverviewChange}
                                                                                    toolbarClassName="toolbarClassName"
                                                                                    wrapperClassName="wrapperClassName"
                                                                                    editorClassName="editorClassName"
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </Col>
                                                                </Row>
                                                            </TabPane>
                                                            <TabPane tabId={4}>
                                                                <div className="row justify-content-center">
                                                                    <Col lg="6">
                                                                        <div className="text-center">
                                                                            <div className="mb-4">
                                                                                <i className="mdi mdi-check-circle-outline text-success display-4" />
                                                                            </div>
                                                                            <div>
                                                                                <h5>Confirm Detail</h5>
                                                                                <p className="text-muted">
                                                                                    If several languages coalesce, the grammar of
                                                                                    the resulting
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </div>
                                                                {/* <Col md={12}>
                                                                    <div className="mb-3">
                                                                        <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
                                                                    </div>
                                                                </Col> */}
                                                            </TabPane>
                                                        </TabContent>
                                                    </div>
                                                    <div className="actions clearfix">
                                                        {activeTab != 1 && 
                                                            <Button
                                                            style={{float:"left"}}
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={() => {
                                                                toggleTab(activeTab - 1)
                                                            }}
                                                            >Previous</Button>
                                                        }
                                                        {activeTab === 4 ?
                                                            <Button color="primary" type="submit">
                                                                Submit
                                                            </Button>
                                                            :
                                                            <Link
                                                                to="#"
                                                                className="btn btn-primary"
                                                                onClick={() => {
                                                                    toggleTab(activeTab + 1)
                                                                }}
                                                            >Next</Link>
                                                        }
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </AvForm>
                        </CardBody>
                    </Card>
                </Col>
            }
        </Row>
    )
}

export default Model
